


import screen1 from "./screen1.png";
import screen2 from "./screen2.png";
import screen3 from "./screen3.png";
import screen4 from "./screen4.png";
import screen5 from "./screen5.png";
import screen6 from "./screen6.png";
import screen7 from "./screen7.png";

const project_data = {
    tittle:"NPM React components package for faster and easier web development",
    source:"https://github.com/juanda2222/vissually",
    website:"https://vissually-97134.herokuapp.com",
    abstract:"This is a fully documented npm package with his corresponding demo app. The documentation is hosted on a AWS S3 instance, the app is hosted on heroku and uses a TravisCi pipeline",
    hashtags:["react", "node", "npm", "aws", "typescript", "heroku", "travisci", "materialui"],
    prev_image_index: 0,
    images:[
        {
            caption:"Home page", 
            image:screen1
        },
        {
            caption:"Menu page", 
            image:screen2
        },
        {
            caption:"Dark mode", 
            image:screen3
        },
        {
            caption:"Button dark mode", 
            image:screen4
        },
        {
            caption:"Documentation home", 
            image:screen5
        },
        {
            caption:"Documentation component", 
            image:screen6
        },
        {
            caption:"Documentation component args", 
            image:screen7
        }
    ]
}

export default project_data
